const defaultContent = {
  title: 'Software developer',
  description: 'Passionate web developer and cross-functional team player, with +5 years of experience working mainly on Front-end / JavaScript projects, with a proven potential to grow self and others.',
};
export default defaultContent;
